import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { PermissionService } from '@core/services/permission.service';
import { APP_ROUTES } from '@core/constants/app-routes.const';
import { LucideShieldAlert } from '@lucide/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-error-403',
  standalone: true,
  imports: [RouterModule, TranslateModule, LucideShieldAlert],
  template: `
    <div
      class="auth-container d-flex align-items-center justify-content-center"
    >
      <div class="auth-wrapper maxw-480 text-center mx-auto">
        <!-- Logo 4SGen -->
        <h1 class="auth-logo mb-4">4SGen</h1>

        <!-- Error Card -->
        <div class="auth-card p-5 rounded-3 shadow-lg text-center">
          <div
            class="p-2 d-inline-flex p-20 rounded-circle bg-danger-subtle mb-4"
          >
            <svg lucideShieldAlert class="text-danger width-80 height-80"></svg>
          </div>

          <h2 class="form-title mb-3 text-danger">
            {{ 'ERROR_403.TITLE' | translate }}
          </h2>

          <p class="form-subtitle mb-5">
            {{ 'ERROR_403.MESSAGE' | translate }}
          </p>

          <div class="d-grid gap-2">
            @if (accessibleRoute) {
              <button
                class="btn btn-success fw-bold"
                (click)="goToAuthorized()"
              >
                {{ 'ERROR_403.BACK_TO_AUTHORIZED' | translate }}
              </button>
            }
            <button
              class="btn btn-primary fw-bold"
              (click)="authService.logout()"
            >
              {{ 'ERROR_403.BUTTON' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class Error403Component {
  readonly authService = inject(AuthService);
  private readonly permissionService = inject(PermissionService);
  private readonly router = inject(Router);

  get accessibleRoute(): string | null {
    const route = this.permissionService.getFirstAccessibleRoute();
    const forbiddenPath = '/' + APP_ROUTES.FORBIDDEN;
    if (route && route !== forbiddenPath && route !== APP_ROUTES.FORBIDDEN) {
      return route;
    }
    return null;
  }

  goToAuthorized() {
    const route = this.accessibleRoute;
    if (route) {
      this.router.navigate([route]);
    }
  }
}
